export { ScopeCode as ScopeCodeField } from './ScopeCode';
